"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.array.find");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helper = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _latlonGeohash = _interopRequireDefault(require("latlon-geohash"));

var _moment = _interopRequireDefault(require("moment"));

var _publicIp = _interopRequireDefault(require("public-ip"));

var _lodash = require("lodash");

var _jnplHelper = require("jnpl-helper");

var _lastMileDelivery = require("@/api/last-mile-delivery.api");

var _lastMileDeliveryPricerite = require("@/api/last-mile-delivery-pricerite.api");

var _lastMileDeliveryWellcome = require("@/api/last-mile-delivery-wellcome.api");

var _lastMileV = require("@/api/last-mile-v2.api");

var _milkRun = require("@/api/milk-run.api");

var _order = require("@/api/order.api");

var _orderV = require("@/api/order-v2.api");

var _truck = require("@/api/truck.api");

var Helper = /*#__PURE__*/function () {
  function Helper() {
    (0, _classCallCheck2.default)(this, Helper);
    this.env = process.env.NODE_ENV;
  }

  (0, _createClass2.default)(Helper, [{
    key: "randomColor",
    get: function get() {
      var color = '#' + (Math.random() * 0xffffff << 0).toString(16);
      return color.length === 7 ? color : "".concat(color, "9");
    }
  }, {
    key: "currentDate",
    get: function get() {
      var dateObj = new Date();
      return dateObj.getFullYear() + '-' + (0, _jnplHelper.pad)(dateObj.getMonth() + 1) + '-' + (0, _jnplHelper.pad)(dateObj.getDate());
    }
  }, {
    key: "get",
    value: function get(data) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return (0, _lodash.get)(data, value, defaultValue);
    }
  }, {
    key: "removeDuplicateArrayObject",
    value: function removeDuplicateArrayObject() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return (0, _jnplHelper.removeDuplicateArrayObject)(array, param);
    }
  }, {
    key: "incrementColor",
    value: function incrementColor() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var increment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      return (0, _jnplHelper.incrementColor)(color, increment);
    }
  }, {
    key: "filter",
    value: function filter(data, func) {
      return (0, _lodash.filter)(data, func);
    }
  }, {
    key: "findIndex",
    value: function findIndex(collection, func) {
      return (0, _lodash.findIndex)(collection, func);
    }
  }, {
    key: "cloneDeep",
    value: function cloneDeep(value) {
      return (0, _lodash.cloneDeep)(value);
    }
  }, {
    key: "includes",
    value: function includes() {
      return _lodash.includes.apply(void 0, arguments);
    }
  }, {
    key: "difference",
    value: function difference() {
      return _lodash.difference.apply(void 0, arguments);
    }
  }, {
    key: "differenceBy",
    value: function differenceBy() {
      return _lodash.differenceBy.apply(void 0, arguments);
    }
  }, {
    key: "intersection",
    value: function intersection() {
      return _lodash.intersection.apply(void 0, arguments);
    }
  }, {
    key: "intersectionBy",
    value: function intersectionBy() {
      return _lodash.intersectionBy.apply(void 0, arguments);
    }
  }, {
    key: "map",
    value: function map() {
      return _lodash.map.apply(void 0, arguments);
    }
  }, {
    key: "uniq",
    value: function uniq() {
      return _lodash.uniq.apply(void 0, arguments);
    }
  }, {
    key: "forEach",
    value: function forEach() {
      return _lodash.forEach.apply(void 0, arguments);
    }
  }, {
    key: "find",
    value: function find() {
      return _lodash.find.apply(void 0, arguments);
    }
  }, {
    key: "findLast",
    value: function findLast() {
      return _lodash.findLast.apply(void 0, arguments);
    }
  }, {
    key: "extend",
    value: function extend() {
      return _lodash.extend.apply(void 0, arguments);
    }
  }, {
    key: "sortBy",
    value: function sortBy() {
      return _lodash.sortBy.apply(void 0, arguments);
    }
  }, {
    key: "every",
    value: function every() {
      return _lodash.every.apply(void 0, arguments);
    }
  }, {
    key: "some",
    value: function some() {
      return _lodash.some.apply(void 0, arguments);
    }
  }, {
    key: "sum",
    value: function sum(value) {
      return (0, _lodash.sum)(value);
    }
  }, {
    key: "uniqBy",
    value: function uniqBy() {
      return _lodash.uniqBy.apply(void 0, arguments);
    }
  }, {
    key: "sumBy",
    value: function sumBy() {
      return _lodash.sumBy.apply(void 0, arguments);
    }
  }, {
    key: "remove",
    value: function remove() {
      return _lodash.sumBy.apply(void 0, arguments);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      return (0, _lodash.isEmpty)(value);
    }
  }, {
    key: "groupBy",
    value: function groupBy() {
      return _lodash.groupBy.apply(void 0, arguments);
    }
  }, {
    key: "flatten",
    value: function flatten(value) {
      return (0, _lodash.flatten)(value);
    }
  }, {
    key: "orderBy",
    value: function orderBy() {
      return _lodash.orderBy.apply(void 0, arguments);
    }
  }, {
    key: "findLastIndex",
    value: function findLastIndex() {
      return _lodash.findLastIndex.apply(void 0, arguments);
    }
  }, {
    key: "values",
    value: function values(value) {
      return (0, _lodash.values)(value);
    }
  }, {
    key: "maxBy",
    value: function maxBy() {
      return _lodash.maxBy.apply(void 0, arguments);
    }
  }, {
    key: "minBy",
    value: function minBy() {
      return _lodash.minBy.apply(void 0, arguments);
    }
  }, {
    key: "isEqual",
    value: function isEqual(value, other) {
      return (0, _lodash.isEqual)(value, other);
    }
  }, {
    key: "toPairs",
    value: function toPairs(object) {
      return (0, _lodash.toPairs)(object);
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var jsonData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _jnplHelper.toJson)(jsonData);
    }
  }, {
    key: "toString",
    value: function toString() {
      var jsonData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _jnplHelper.toString)(jsonData);
    }
  }, {
    key: "isNotEmpty",
    value: function isNotEmpty() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return (0, _jnplHelper.isNotEmpty)(v);
    }
  }, {
    key: "isUndefined",
    value: function isUndefined() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      v = v ? typeof v === 'string' ? v.toLowerCase() : v : null;
      return v == null || v === 'n/a' || v === '' || v === 'no' || v === 0 || v === 'undefined' || v === 'nan' || v === 'na' || v === ' ' || v === 'false' || v === 'null';
    }
  }, {
    key: "isInArray",
    value: function isInArray(value, array) {
      return (0, _jnplHelper.isInArray)(value, array);
    }
  }, {
    key: "isEmptyObject",
    value: function isEmptyObject() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _jnplHelper.isEmptyObject)(obj);
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_DOMAIN;
    }
  }, {
    key: "setCookie",
    value: function setCookie() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var exdays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;

      if (this.isUndefined(domain)) {
        domain = this.getDomain();
      }

      return process.env.NODE_ENV === 'development' ? (0, _jnplHelper.setCookie)(name, value, domain, exdays) : this.setCookieOveride(name, value, domain);
    } // NOTE: force cookie to expire on midnight

  }, {
    key: "setCookieOveride",
    value: function setCookieOveride() {
      var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cvalue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var midnight = new Date();
      midnight.setHours(23, 59, 59, 0);
      var expires = 'expires=' + midnight.toUTCString();

      if (typeof document !== 'undefined') {
        document.cookie = cname + '=' + (0, _jnplHelper.toString)(cvalue) + ';' + expires + ';domain=' + domain + ';path=/';
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "getCookie",
    value: function getCookie() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _jnplHelper.getCookie)(name);
    }
  }, {
    key: "deleteCookie",
    value: function deleteCookie() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return (0, _jnplHelper.deleteCookie)(name, domain);
    }
  }, {
    key: "isValidToken",
    value: function isValidToken() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cookie = this.getCookie(name);
      var cookieData = cookie ? (0, _jnplHelper.decode)(process.env.VUE_APP_SECRET_KEY_HASH || '', cookie).split('|') : {};
      return !(0, _jnplHelper.isEmptyObject)(cookieData);
    }
  }, {
    key: "cleanDataRemoveNull",
    value: function cleanDataRemoveNull(data) {
      return (0, _jnplHelper.cleanDataRemoveNull)(data);
    }
  }, {
    key: "encode",
    value: function encode(data) {
      return Buffer.from(data).toString('base64');
    }
  }, {
    key: "decode",
    value: function decode(data) {
      return Buffer.from(data, 'base64').toString('ascii');
    } // add zero on the start of one digit numbers

  }, {
    key: "pad",
    value: function pad(number) {
      return number < 10 ? '0' + number : number.toString();
    }
  }, {
    key: "toggleTheme",
    value: function toggleTheme(element, className) {
      if (!element || !className) {
        return;
      }

      var classString = element.className;
      var nameIndex = classString.indexOf(className);

      if (classString !== '') {
        var classIndex = classString.indexOf(classString);
        classString = classString.substr(0, classIndex) + classString.substr(classIndex + classString.length);
      }

      nameIndex === -1 ? classString += '' + className : classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
      element.className = classString;
    }
  }, {
    key: "hashBounderies",
    value: function hashBounderies() {
      var geohash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      try {
        return _latlonGeohash.default.bounds(geohash);
      } catch (error) {
        return null;
      }
    }
  }, {
    key: "hashEncode",
    value: function hashEncode() {
      var latitude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var longitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      try {
        return _latlonGeohash.default.encode(latitude, longitude, precision).toString();
      } catch (error) {
        return null;
      }
    }
  }, {
    key: "printThousandDecimal",
    value: function printThousandDecimal(number) {
      return parseFloat(parseFloat(number).toFixed(5)).toLocaleString();
    }
  }, {
    key: "isEmptyString",
    value: function isEmptyString(str) {
      return this.isUndefined(str) || !str.replace(/\s/g, '').length;
    }
  }, {
    key: "removeWhitespace",
    value: function removeWhitespace(str) {
      return str.replace(/\s/g, '');
    }
  }, {
    key: "getFilterQuery",
    value: function getFilterQuery(filters) {
      var _this = this;

      var queryAnd = [];
      var queryOr = [];

      if (filters.length >= 1) {
        filters.forEach(function (f) {
          if (!f.exactValue && f.key && f.value) {
            if (f.queryType === 'AND' || _this.isUndefined(f.queryType)) {
              var index = queryAnd.findIndex(function (item) {
                return item.toLowerCase().includes(f.key.toLowerCase());
              });

              if (index === -1) {
                queryAnd.push("".concat(f.key, ":").concat(f.value));
              } else {
                queryAnd[index] = "".concat(queryAnd[index], ",").concat(f.value);
              }
            }

            if (f.queryType === 'OR') {
              var _index = queryOr.findIndex(function (item) {
                return item.toLowerCase().includes(f.key.toLowerCase());
              });

              if (_index === -1) {
                queryOr.push("".concat(f.key, ":").concat(f.value));
              } else {
                queryOr[_index] = "".concat(queryOr[_index], ",").concat(f.value);
              }
            }
          }
        });
      }

      queryAnd = queryAnd.join('|');
      queryOr = queryOr.join('~');
      return {
        queryAnd: queryAnd,
        queryOr: queryOr
      };
    }
  }, {
    key: "getExactFilterQuery",
    value: function getExactFilterQuery(filters) {
      var query = [];

      if (filters.length >= 1) {
        var localFilter = filters.reduce(function (finalFltr, fltr) {
          if (fltr['exactValue'] && fltr['key'] && fltr['value']) {
            finalFltr[fltr['key']] = finalFltr[fltr['key']] ? "".concat(finalFltr[fltr['key']], ",").concat(fltr['value']) : finalFltr[fltr['key']] = fltr['value'];
          }

          return finalFltr;
        }, {});

        for (var key in localFilter) {
          if (localFilter.hasOwnProperty(key)) {
            query.push("".concat(key, ":").concat(localFilter[key]));
          }
        }
      }

      return query.join('|');
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait, immediate) {
      var _this2 = this;

      var timeout, args, context, timestamp, result;

      var later = function later() {
        var last = +new Date() - timestamp;

        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;

          if (!immediate) {
            result = func.apply(context, args);

            if (!timeout) {
              context = args = null;
            }
          }
        }
      };

      return function () {
        for (var _len = arguments.length, argmnts = new Array(_len), _key = 0; _key < _len; _key++) {
          argmnts[_key] = arguments[_key];
        }

        context = _this2;
        timestamp = +new Date();
        var callNow = immediate && !timeout;

        if (!timeout) {
          timeout = setTimeout(later, wait);
        }

        if (callNow) {
          result = func.apply(context, argmnts);
          context = argmnts = null;
        }

        return result;
      };
    }
  }, {
    key: "getLastMileDeliveryAPI",
    value: function getLastMileDeliveryAPI(rootState) {
      return new _lastMileDelivery.LastMileDeliveryAPI({
        customerKey: rootState['authentication']['userInformation']['customerKey'] || '',
        userSetting: rootState['authentication']['userSetting'] || {},
        lfToken: rootState['authentication']['lfToken'] || null
      });
    }
  }, {
    key: "getLastMileDeliveryPriceriteAPI",
    value: function getLastMileDeliveryPriceriteAPI(rootState) {
      return new _lastMileDeliveryPricerite.LastMileDeliveryPriceriteAPI({
        customerKey: rootState['authentication']['userInformation']['customerKey'] || '',
        userInformation: rootState['authentication']['userInformation'] || {},
        userSetting: rootState['authentication']['userSetting'] || {},
        lfToken: rootState['authentication']['lfToken'] || null
      });
    }
  }, {
    key: "getLastMileDeliveryWellcomeAPI",
    value: function getLastMileDeliveryWellcomeAPI(rootState) {
      return new _lastMileDeliveryWellcome.LastMileDeliveryWellcomeAPI({
        customerKey: rootState['authentication']['userInformation']['customerKey'] || '',
        userInformation: rootState['authentication']['userInformation'] || {},
        userSetting: rootState['authentication']['userSetting'] || {},
        lfToken: rootState['authentication']['lfToken'] || null
      });
    }
  }, {
    key: "getLastMileV2API",
    value: function getLastMileV2API(rootState) {
      return new _lastMileV.LastMileV2API({
        customerKey: rootState['authentication']['userInformation']['customerKey'] || '',
        userInformation: rootState['authentication']['userInformation'] || {},
        userSetting: rootState['authentication']['userSetting'] || {},
        lfToken: rootState['authentication']['lfToken'] || null
      });
    }
  }, {
    key: "getMilkRunAPI",
    value: function getMilkRunAPI(rootState) {
      return new _milkRun.MilkRunAPI({
        customerKey: rootState['authentication']['userInformation']['customerKey'] || '',
        userSetting: rootState['authentication']['userSetting'] || {},
        lfToken: rootState['authentication']['lfToken'] || null
      });
    }
  }, {
    key: "getOrderAPI",
    value: function getOrderAPI(rootState) {
      return new _order.OrderAPI({
        lfToken: rootState['authentication']['lfToken'] || null,
        userSetting: rootState['authentication']['userSetting'] || {},
        userData: rootState['authentication']['userData'] || {}
      });
    }
  }, {
    key: "getOrderV2API",
    value: function getOrderV2API(rootState) {
      return new _orderV.OrderV2API({
        lfToken: rootState['authentication']['lfToken'] || null,
        userSetting: rootState['authentication']['userSetting'] || {},
        userData: rootState['authentication']['userData'] || {}
      });
    }
  }, {
    key: "getTruckAPI",
    value: function getTruckAPI(rootState) {
      return new _truck.TruckAPI({
        lfToken: rootState['authentication']['lfToken'] || null,
        userSetting: rootState['authentication']['userSetting'] || {}
      });
    }
  }, {
    key: "generateNewPlanId",
    value: function generateNewPlanId(userFormat, planDate, userInfo) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'lastmile';
      var customId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var date = (0, _jnplHelper.isNotEmpty)(planDate) ? (0, _moment.default)(planDate).format('YYMMDD') : '';
      var finalCompCode = '';
      var str = userInfo['company']['name'].replace(/[^a-zA-Z0-9 ]/g, '').split(' ');
      str.forEach(function (char) {
        finalCompCode = finalCompCode + char.charAt(0);
      });
      var planIdParam = {
        date: date,
        compId: userInfo['company']['id'] || '',
        compCode: finalCompCode,
        customId: customId || ''
      };
      var finalFormat = (0, _jnplHelper.replaceHtml)(userFormat, planIdParam);
      var firstFinalFormat = finalFormat.charAt(0);

      if (firstFinalFormat === '-') {
        finalFormat = finalFormat.substring(1);
      }

      return finalFormat;
    }
  }, {
    key: "getDates",
    value: function getDates(startDate, endDate) {
      var dates = [];
      var currentDate = startDate;

      var addDays = function addDays(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };

      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }

      return dates;
    }
  }, {
    key: "secondsToHms",
    value: function secondsToHms(seconds) {
      seconds = Number(seconds);
      var h = Math.floor(seconds / 3600);
      var m = Math.floor(seconds % 3600 / 60);
      var s = Math.floor(seconds % 3600 % 60); // const hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      // const mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      // const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      var hDisplay = h > 0 ? h.toString().padStart(2, '0') : '00';
      var mDisplay = m > 0 ? ':' + m.toString().padStart(2, '0') : ':00';
      var sDisplay = s > 0 ? ':' + s.toString().padStart(2, '0') : ':00';
      return hDisplay + mDisplay + sDisplay;
    }
  }, {
    key: "convertTimezone",
    value: function convertTimezone(d) {
      var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD HH:mm';

      if (this.isUndefined(d)) {
        return d;
      }

      d = d.toString();

      if (timezone !== 8) {
        var date = _moment.default.utc(d).subtract(8, 'hours').utcOffset(timezone);

        return date.format(format);
      } else {
        return (0, _moment.default)(d).format(format);
      }
    }
  }, {
    key: "revertTimezone",
    value: function revertTimezone(d) {
      var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD HH:mm';

      if (this.isUndefined(d)) {
        return d;
      }

      d = d.toString();

      if (timezone !== 8) {
        var nTimezone = timezone;

        if (timezone >= 0) {
          nTimezone = -Math.abs(timezone);
        } else {
          nTimezone = Math.abs(timezone);
        }

        var date = _moment.default.utc(d).add(8, 'hours').utcOffset(nTimezone);

        return date.format(format);
      } else {
        return (0, _moment.default)(d).format(format);
      }
    }
  }, {
    key: "getIPAddress",
    value: function () {
      var _getIPAddress = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _publicIp.default.v4();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getIPAddress() {
        return _getIPAddress.apply(this, arguments);
      }

      return getIPAddress;
    }()
  }, {
    key: "ymdToString",
    value: function ymdToString(date) {
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    }
  }, {
    key: "dateToString",
    value: function dateToString(date) {
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') + ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ':' + String(date.getSeconds()).padStart(2, '0');
    }
  }, {
    key: "downloadFile",
    value: function downloadFile(data) {
      var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
      var fileExt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'xlsx';
      var url;

      if (fileExt === 'json') {
        var dataStr = this.toString(data);
        url = window.URL.createObjectURL(new Blob([dataStr], {
          type: 'application/json'
        }));
      } else {
        url = window.URL.createObjectURL(new Blob([data]));
      }

      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "".concat(filename, ".").concat(fileExt));
      document.body.appendChild(link);
      link.click();
    }
  }, {
    key: "subtractCurrentDate",
    value: function subtractCurrentDate(days) {
      var dateObj = new Date();
      dateObj.setDate(dateObj.getDate() - days);
      return dateObj.getFullYear() + '-' + (0, _jnplHelper.pad)(dateObj.getMonth() + 1) + '-' + (0, _jnplHelper.pad)(dateObj.getDate());
    }
  }, {
    key: "addCurrentDate",
    value: function addCurrentDate(days) {
      var dateObj = new Date();
      dateObj.setDate(dateObj.getDate() + days);
      return dateObj.getFullYear() + '-' + (0, _jnplHelper.pad)(dateObj.getMonth() + 1) + '-' + (0, _jnplHelper.pad)(dateObj.getDate());
    }
  }, {
    key: "PNSCustomId",
    value: function PNSCustomId(userData, orders) {
      var customId = '';

      if ([195].includes(Number(userData['company']['id'])) && orders && orders.length >= 1) {
        if (orders[0]['pickBuilding'] && orders[0]['pickBuilding'].toLowerCase().includes('942')) {
          customId = '942';
        } else {
          customId = '275';
        }
      }

      return customId;
    }
  }, {
    key: "getColWidth",
    value: function getColWidth(colName) {
      switch (colName) {
        case 'index':
          return 60;
        // For Order

        case 'zone':
          return 100;

        case 'serviceType':
          return 200;

        case 'pickDateTime':
        case 'pickDistrict':
        case 'pickPhoneNumber':
        case 'dropDateTime':
        case 'dropDistrict':
        case 'dropPhoneNumber':
          return 160;

        case 'pickBuilding':
        case 'pickCompName':
        case 'pickName':
        case 'dropBuilding':
        case 'dropCompName':
        case 'dropName':
          return 260;

        case 'weight':
          return 120;

        case 'volume':
        case 'quantity':
        case 'cartons':
        case 'pallets':
          return 100;

        case 'remarks':
          return 300;

        case 'itemInfo':
          return 600;

        case 'assemblyMinutes':
        case 'wallMountQuantity':
        case 'disposalQuantity':
        case 'staircaseQuantity':
          return 160;

        default:
          return 140;
      }
    }
  }]);
  return Helper;
}();

exports.Helper = Helper;